import { render } from "./NewLogin.vue?vue&type=template&id=b4aa499c&scoped=true"
import script from "./NewLogin.vue?vue&type=script&lang=js"
export * from "./NewLogin.vue?vue&type=script&lang=js"

import "./NewLogin.vue?vue&type=style&index=0&id=b4aa499c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4aa499c"]])

export default __exports__